import {PayRecordDO} from "@/declares/entity/payCenter/PayRecordDO";


export class PayRecordSearchVO extends PayRecordDO {
  userNickName: string = '';
  merchantId: number = null as any;
  merchantName: string = '';
  payAppId: number = null as any;
  appName: string = '';
}
